import styled, { createGlobalStyle } from 'styled-components';
import {
  REBRAND_COLOR,
  BREAKPOINT,
  PADDING
} from '@latitude/core/utils/constants';
import { MARGIN } from '@/utils/constants';

/* Global */
export const StyledModalGlobalStyle = createGlobalStyle`
  .ReactModal__Body--open {
    overflow-y: hidden;
  }
`;

/* Overlay */
export const StyledModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.35);
  opacity: 0;
  transition: opacity 200ms ease-in-out;
  z-index: 30000;

  &.ReactModal__Overlay--after-open {
    opacity: 1;
  }

  &.ReactModal__Overlay--before-close {
    opacity: 0;
  }
`;

/* Panel */
export const StyledModalPanel = styled.div`
  background: ${REBRAND_COLOR.WHITE};
  border: none;
  box-shadow: 0 0 0.5rem 0.02rem hsla(210, 3%, 41%, 0.5);
  color: #4a4a4a;
  display: flex;
  flex-direction: column;
  padding: ${PADDING.P32} ${PADDING.P20} !important;
  margin: auto;
  height: fit-content;
  max-height: 384px;
  width: ${({ width }) => (width ? width : '80%')};
  overflow-y: auto;
  &:focus {
    outline: none;
  }

  @media (min-width: ${BREAKPOINT.LG}) {
    max-height: fit-content;
    width: ${({ width }) => (width ? width : '60%')};
    max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : 'fit-content')};
  }
  @media (min-width: ${BREAKPOINT.MD}) {
    padding: ${PADDING.P32} !important;
  }

  svg path {
  fill: ${REBRAND_COLOR.INDIGO};
}
`;

/* Header */
export const StyledModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: ${MARGIN.M16};

  p {
   margin: 0;
  }
`;

/* Title */
export const StyledModalTitle = styled.h5``;

/* Close */
export const StyledModalCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

/* Content */
export const StyledModalContent = styled.div`
  p {
   margin: 0;
  }
    p:empty {
      margin: ${MARGIN.M16};
    }
`;
